import { render, staticRenderFns } from "./PostsListing.vue?vue&type=template&id=13e27dba&"
import script from "./PostsListing.vue?vue&type=script&lang=js&"
export * from "./PostsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports